<template>
  <div class="category-admin ml-4 mr-4" v-if="user.id_grupo==18 || user.id_grupo==9" >
      <b-form>
        <input id="category-id"  type="hidden" v-model="category.id" />
                  <b-form-group label="Nome:" label-for="category-name">
                      <b-form-input id="category-name" type="text"
                        v-model="category.name" required
                        :readonly="mode === 'remove'"
                        placeholder="Informe o nome do menu" />
                  </b-form-group>
                  <b-form-group label="Categoria Pai:" label-for="category-parentId">
                     
                    <b-form-select v-if="mode === 'save'"
                      id="category-parentId"
                      :options="categories" v-model="category.parentId" />
                    <b-form-input v-else
                      id="category-parentId" type="text"
                      v-model="category.path" 
                      readonly />                                         
                  </b-form-group>                                    
                  <b-button size="sm" variant="primary" v-if="mode === 'save'"
                    @click="save" >Salvar</b-button>
                  <b-button size="sm" variant="danger" v-if="mode === 'remove'"
                    @click="remove">Excluir</b-button>
                  <b-button size="sm" class="ml-2" @click="reset">Cancelar</b-button>          
    </b-form>
    <hr>
    <b-table small hover striped sticky-header="556px" :items="categories" :fields="fields">                            
        <template slot="cell(actions)" slot-scope="data">
            <b-button size="sm" variant="warning" @click="loadCategory(data.item)" class="mr-2">
                <i class="fa fa-pencil"></i>
            </b-button>
            <b-button size="sm" variant="danger" @click="loadCategory(data.item, 'remove')">
                <i class="fa fa-trash"></i>
            </b-button>
        </template>
    </b-table>      
    </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import { mapState } from 'vuex' 

export default {

    computed : { ... mapState (['user'],),} ,


    name: 'CategoryAdmin',
    data: function() {
        return {
            mode: 'save',
            category: {},
            categories: [],
            fields: [
                { key: 'id', label: 'Código', sortable: true },
                { key: 'name', label: 'Nome', sortable: true },
                { key: 'path', label: 'Caminho', sortable: true },
                { key: 'actions', label: 'Ações' }
            ]
        }
    },
    methods: {
        loadCategories() {
            const url = `${baseApiUrl}/categories`
            axios.get(url).then(res => {
                // this.categories = res.data
                this.categories = res.data.map(category => {
                    return { ...category, value: category.id, text: category.path }
                })
            })
        },
        reset() {
            this.mode = 'save'
            this.category = {}
            this.loadCategories()
        },
        save() {
            const method = this.category.id ? 'put' : 'post'
            const id = this.category.id ? `/${this.category.id}` : ''
            axios[method](`${baseApiUrl}/categories${id}`, this.category)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        remove() {
            const id = this.category.id
            axios.delete(`${baseApiUrl}/categories/${id}`)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        loadCategory(category, mode = 'save') {
            this.mode = mode
            this.category = { ...category } // espred do obj , setando e carregando o Categoria
        }
    },
    mounted() {
        this.loadCategories()
    }
}
</script>

<style>

</style>